import { Autocomplete, AutocompleteChangeDetails, Button, Checkbox, FormControlLabel, Grid, TextField, Tooltip } from '@mui/material';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { setTriggerMyFixtureSearch, resetMyFixtureSearch, setTriggerFocusVesselName, setVesselNames, setYear, setSupport, setBrokers, setStatuses, setHasInvNo, setBizTypes, setHasEvaluation, setShowCloseFile, setReceivedDateYear } from './reducers/MyFixtureSearchReducer';
import MyFixtureApi, { SearchMyFixtureParam } from './api/MyFixtureApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import SavedSearch, { ComponentType } from '../SavedSearch/SavedSearch';
import Swal from 'sweetalert2';
import SavedSearchApi, { SaveSavedSearchParam } from '../SavedSearch/api/SavedSearchApi';
import SavedSearchModel from '../SavedSearch/models/SavedSearchModel';
import { addSavedSearch } from '../SavedSearch/reducers/SavedSearchReducer';
import { MyFixtureSearchSelector } from './reducers/MyFixtureSearchReducer';
import TagsFilter from '../TagFilter/TagsFilter';
import { QueryItem } from '../Tonnage/models/TonnageQueryModel';
import { tonnageInputSelector } from '../Tonnage/reducers/TonnageInputReducer';
import { setUserDisplayNames, userSelectorSelector } from '../UserSelector/reducers/UserSelectorReducer';
import FixtureModel from '../FixtureManagement/models/FixtureModel';
import UserSelector from '../UserSelector/UserSelector';
import UserApi from '../UserManagement/api/UserApi';
import UserDisplayNameModel from '../UserSelector/models/UserDisplayNameModel';
import { HasEnumValue, HasEvaluationValue } from './models/MyFixtureQueryModel';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import { setMyFixtures } from './reducers/MyFixtureReducer';

export let getYears = () => {
    let firstYear = 2020;
    let currentYear = new Date().getFullYear();
    let years = [0];

    for (let year = firstYear; year <= currentYear; year++) {
        years.push(year);
    }

    return years;
};


const MyFixtureSearch: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const MyFixtureSearchData = useSelector(MyFixtureSearchSelector);
    const tonnageViewData = useSelector(tonnageInputSelector);
    const userSelectorData = useSelector(userSelectorSelector);

    let getRecvDateYears = () => {
        let firstYear = 2020;
        let currentYear = new Date().getFullYear();
        let years = [-2, -1, 0];

        for (let year = firstYear; year <= currentYear; year++) {
            years.push(year);
        }

        return years;
    }

    const saveSavedSearch = () => {
        Swal.fire({
            title: 'Provide Saved Search Name',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Sumbit',
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            confirmButtonColor: '#1976d2',
            preConfirm: (name) => {
                if (!name || name.length === 0) {
                    Swal.showValidationMessage("Name ")
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showLoading(true));

                SavedSearchApi.Save({
                    name: result.value ? result.value : "",
                    component: ComponentType.MyFixture,
                    queryJson: JSON.stringify(MyFixtureSearchData.query)
                } as SaveSavedSearchParam)
                    .then((response: BaseResponse<SavedSearchModel>) => {
                        if (response.success) {
                            dispatch(addSavedSearch(response.data));
                            Utility.Alert.Success("Save Successful");
                        } else {
                            Utility.Alert.Error(response.message);
                        }
                    })
                    .catch((error) => {
                        Utility.Alert.Error(error);
                    })
                    .finally(() => {
                        dispatch(showLoading(false));
                    });
            }
        })
    }

    useEffect(() => {
        if (userSelectorData.userDisplayNames.length === 0) {
            UserApi.GetDisplayNames()
                .then((response: BaseResponse<UserDisplayNameModel[]>) => {
                    if (response.success) {
                        dispatch(setUserDisplayNames(response.data))
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
        }
    }, [])

    useEffect(() => {
        if (MyFixtureSearchData.triggerSearch === 0) {
            return;
        }

        dispatch(showLoading(true));

        MyFixtureApi.Search({
            query: MyFixtureSearchData.query
        } as SearchMyFixtureParam)
            .then((response: BaseResponse<FixtureModel[]>) => {
                if (response.success) {
                    dispatch(setMyFixtures(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }, [MyFixtureSearchData.triggerSearch])


    return (
        <>
            <Grid container>
                <Grid item xs={2} className="MyFixture-save-search">
                    <SavedSearch
                        component={ComponentType.MyFixture}
                    >
                    </SavedSearch>
                </Grid>
                <Grid item xs={10}>
                    <CustomAccordion
                        title="Search"
                        className="MyFixture-search-area"
                        defaultOpen={true}>
                        <Grid container>
                            <Grid xs={3} className="MyFixture-button">
                                <Grid container>
                                    <Grid xs={8}>
                                        <Tooltip title="Alt + W">
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                className="tonnage-search-save-button"
                                                onClick={() => {
                                                    dispatch(setTriggerMyFixtureSearch((new Date()).getTime()));
                                                }}
                                            >
                                                RUN SEARCH (w)
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Tooltip title="Reset (Alt + Q)">
                                            <Button
                                                className="clear-input-button"
                                                color="success"
                                                variant="contained"
                                                onClick={() => {
                                                    dispatch(resetMyFixtureSearch());
                                                    dispatch(setTriggerFocusVesselName((new Date()).getTime()));
                                                }}
                                            >
                                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={11} className="MyFixture-search-item">
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            onClick={() => {
                                                saveSavedSearch();
                                            }}
                                        >
                                            Save Search
                                        </Button>
                                    </Grid>
                                    <Grid item xs={1}></Grid>
                                </Grid>

                                <FormControlLabel control={
                                    <Checkbox
                                        checked={MyFixtureSearchData.query.showCloseFile}
                                        onChange={(event) => {
                                            dispatch(setShowCloseFile(event.target.checked));
                                        }}
                                    />}
                                    className="tonnage-input-grabs"
                                    label="Show Closed File"
                                />
                            </Grid>
                            <Grid xs={9}>
                                <Grid container>
                                    <Grid xs={4}>
                                        <Autocomplete
                                            disableClearable={true}
                                            fullWidth
                                            options={getYears()}
                                            renderInput={(params) => <TextField {...params} label="Year" />}
                                            className='cargo-input-component'
                                            getOptionLabel={(option: number) => {
                                                if (option == 0) {
                                                    return "All Years";
                                                } else {
                                                    return option.toString();
                                                }
                                            }}
                                            value={MyFixtureSearchData.query.year}
                                            onChange={(event: React.SyntheticEvent, value: number, reason: string, details?: AutocompleteChangeDetails<number> | undefined) => {
                                                dispatch(setYear(value));
                                            }}
                                        />
                                        <UserSelector
                                            label='Support'
                                            className='cargo-input-component'
                                            selectedUserId={MyFixtureSearchData.query.support}
                                            onUserIdChange={(value: number) => {
                                                dispatch(setSupport(value));
                                            }}
                                        >
                                        </UserSelector>
                                        <TagsFilter
                                            data={[
                                                {
                                                    id: "OnGoing",
                                                    value: "OnGoing",
                                                    positive: true
                                                } as QueryItem,
                                                {
                                                    id: "Outstanding",
                                                    value: "Outstanding",
                                                    positive: true
                                                } as QueryItem,
                                                {
                                                    id: "Pending Commission",
                                                    value: "Pending Commission",
                                                    positive: true
                                                } as QueryItem,
                                                {
                                                    id: "Closed",
                                                    value: "Closed",
                                                    positive: true
                                                } as QueryItem,

                                            ]}
                                            label="Status"
                                            className="fixture-search-item"
                                            value={MyFixtureSearchData.query.statuses}
                                            onValueChange={(value: QueryItem[]) => {
                                                dispatch(setStatuses(value));
                                            }}
                                        ></TagsFilter>
                                    </Grid>
                                    <Grid xs={4}>
                                        <TagsFilter
                                            data={_.map(tonnageViewData.tonnageNames, (item) => {
                                                return {
                                                    id: item.id,
                                                    value: item.vesselName,
                                                    positive: true
                                                } as QueryItem
                                            })}
                                            label="Vessel Name"
                                            className="fixture-search-item"
                                            value={MyFixtureSearchData.query.vesselNames}
                                            useFreeText={true}
                                            onValueChange={(value: QueryItem[]) => {
                                                dispatch(setVesselNames(value))
                                            }}
                                        ></TagsFilter>
                                        <TagsFilter
                                            data={_.map(userSelectorData.userDisplayNames, (item) => {
                                                return {
                                                    id: item.id.toString(),
                                                    value: item.displayName,
                                                    positive: true
                                                } as QueryItem
                                            })}
                                            useFreeText={true}
                                            label="Broker"
                                            className="fixture-search-item"
                                            value={MyFixtureSearchData.query.brokers}
                                            onValueChange={(value: QueryItem[]) => {
                                                dispatch(setBrokers(value))
                                            }}
                                        ></TagsFilter>
                                        <TagsFilter
                                            data={_.map([MarketInfoType.Voy, MarketInfoType.TCT, MarketInfoType.TC, MarketInfoType.COA], (item) => {
                                                return {
                                                    id: item,
                                                    value: item,
                                                    positive: true
                                                } as QueryItem
                                            })}
                                            useFreeText={true}
                                            label="BizTypes"
                                            className="fixture-search-item"
                                            value={MyFixtureSearchData.query.bizTypes}
                                            onValueChange={(value: QueryItem[]) => {
                                                dispatch(setBizTypes(value))
                                            }}
                                        ></TagsFilter>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Autocomplete
                                            disableClearable={true}
                                            fullWidth
                                            options={[HasEnumValue.Yes, HasEnumValue.No, HasEnumValue.All]}
                                            className="fixture-search-item"
                                            renderInput={(params) => <TextField {...params} label="Has Inv No" />}
                                            value={MyFixtureSearchData.query.hasInvNo}
                                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                                dispatch(setHasInvNo(value));
                                            }}
                                        />
                                        <Autocomplete
                                            disableClearable={true}
                                            fullWidth
                                            options={getRecvDateYears()}
                                            renderInput={(params) => <TextField {...params} label="Recv Date Year" />}
                                            className='cargo-input-component'
                                            getOptionLabel={(option: number) => {
                                                if (option == -2) {
                                                    return "All";
                                                } else if (option == -1) {
                                                    return "Haven't received";
                                                } else if (option == 0) {
                                                    return "All Years received";
                                                } else {
                                                    return option.toString();
                                                }
                                            }}
                                            value={MyFixtureSearchData.query.receivedDateYear}
                                            onChange={(event: React.SyntheticEvent, value: number, reason: string, details?: AutocompleteChangeDetails<number> | undefined) => {
                                                dispatch(setReceivedDateYear(value));
                                            }}
                                        />
                                        <Autocomplete
                                            disableClearable={true}
                                            fullWidth
                                            className="fixture-search-item"
                                            options={[HasEvaluationValue.All, HasEvaluationValue.NoEva, HasEvaluationValue.NoS, HasEvaluationValue.NoM, HasEvaluationValue.FullEva]}
                                            renderInput={(params) => <TextField {...params} label="Has Evaluation" />}
                                            value={MyFixtureSearchData.query.hasEvaluation}
                                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                                dispatch(setHasEvaluation(value));
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CustomAccordion>
                </Grid>
            </Grid>
        </>
    )
};

export default MyFixtureSearch;